// Die gemeinsamen Flaechen der Bildschirme (ST-UX-001, ADR-0002).
//
// Sie lagen bisher in `main.tsx` und wurden von allem darin benutzt. Mit zwei
// Bildschirmen in eigenen Dateien waeren sie zweimal entstanden -- und zwei
// Kopien derselben Karte laufen auseinander, bis "konsistente Muster" aus
// NFR-UX-004 nicht mehr stimmt. Eine Datei, ein Muster.
//
// Es entsteht KEINE zweite Styleebene: das hier sind Griffel-Regeln auf
// Fluent-Tokens, genau das, was ADR-0002 vorsieht.

import { makeStyles, tokens } from '@fluentui/react-components';

export const useScreenStyles = makeStyles({
  card: {
    // Ruhige Neutralflaeche mit 1-Pixel-Rand und dem leichten Kartenschatten des
    // Themes (shadow4, v4); schwebende Ebenen (Menue, Dialog) haben mehr.
    padding: '1.25rem',
    // Wie die Karten des Kontakts (v4: Linie UND Schatten).
    boxShadow: tokens.shadow4,
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    // Oben schliesst der erste Inhalt an den Innenabstand an. Eine leere Statusregion bleibt
    // im Baum, sonst ginge die naechste Ansage verloren; sie nimmt aber keinen Platz ein:
    // ihr eigener Abstand entfaellt, und der negative Rand hebt den Abstand der Card-Spalte auf.
    // Eine Ebene tiefer gilt dasselbe: ein Abschnitt, der mit seiner Ueberschrift beginnt.
    '& > :first-child, & > :first-child > :first-child': { marginTop: 0 },
    '& > [aria-live]:empty:not(:last-child)': { marginTop: 0, marginBottom: 'calc(var(--fui-Card--size) * -1)' },
    '& > [aria-live]:empty:first-child + *, & > [aria-live]:empty:first-child + * > :first-child': { marginTop: 0 },
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.75rem',
    marginTop: '0.5rem',
  },
  areas: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    marginTop: '0.75rem',
  },
  detail: {
    // Nur die technische Sicht darf Bezeichner zeigen. Umbruch statt
    // Querscrollen: eine UUID sprengt sonst den 320-Pixel-Reflow.
    fontFamily: tokens.fontFamilyMonospace,
    fontSize: tokens.fontSizeBase200,
    overflowWrap: 'anywhere',
    margin: 0,
  },
  detailRow: {
    display: 'grid',
    gridTemplateColumns: 'minmax(9rem, auto) 1fr',
    gap: '0.25rem 1rem',
    marginBottom: '0.5rem',
  },
  form: {
    // Eine Spalte, Abstaende in rem. Bei 320 Pixeln bleibt es dieselbe
    // Anordnung, nur schmaler -- kein zweiter Umbruchpunkt, den niemand
    // prueft (CM-UX-001).
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    marginTop: '0.75rem',
  },
  formRow: {
    // Zwei Felder nebeneinander, sobald Platz ist; darunter untereinander.
    // minmax(12rem, 1fr) bricht ohne Media Query um und ueberlebt damit auch
    // 200 Prozent Textzoom, bei dem eine Pixelbreite falsch waere.
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(12rem, 1fr))',
    gap: '1rem',
    // Oben ausrichten statt dehnen. Ohne diese Zeile bekommen beide Felder die
    // Hoehe des hoeheren: sobald EINES eine Fehlermeldung traegt, waechst die
    // Zeile, und das Eingabefeld daneben rutscht aus der Flucht. Der Sprung
    // faellt genau im Fehlerfall auf -- also dann, wenn die Nutzerin ohnehin
    // sucht, was schiefging (NFR-UX-004: konsistente Muster).
    alignItems: 'start',
  },
});
